import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import ReactTable from "react-table";
import { toast } from "react-toastify";
import { DatePicker } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserTypes from "components/auth/user-types";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import ServiceReassignmentWidgetFilter from "components/menu/dashboard/service-reassignment-widget-filter";
import {
    fetchServiceReassignment,
    actServiceReassignment
} from "api/menu/dashboard/actions";

class ServiceReassignmentWidget extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null,
        };

        this.makeRequest = this.makeRequest.bind(this);
        this.handleAct = this.handleAct.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.getColumns = this.getColumns.bind(this);

        this.makeRequest();
    }

    getColumns = () => {
        const { userRole } = this.props;

        const showActButton =
            userRole.includes(UserTypes.admin) ||
            userRole.includes(UserTypes.supervisor) ||
            userRole.includes(UserTypes.accountManager);

        return [
            {
                Header: "Job #",
                accessor: "jobNumber"
            },
            {
                Header: "Store #",
                accessor: "storeNumber"
            },
            {
                Header: "Retailer",
                accessor: "retailerFullName"
            },
            {
                Header: "Earliest",
                accessor: "earliestDate",
                Cell: ({ original }) =>
                    moment(original.earliestDate).format("YYYY-MM-DD"),
                Filter: ({ filter, onChange }) => (
                    <DatePicker
                        Format={this.dateFormat}
                        value={filter ? filter.value : null}
                        onChange={date => onChange(date)}
                        placeholder=""
                    />
                )
            },
            {
                Header: "Latest",
                accessor: "latestDate",
                Cell: ({ original }) => moment(original.latestDate).format("YYYY-MM-DD"),
                Filter: ({ filter, onChange }) => (
                    <DatePicker
                        Format={this.dateFormat}
                        value={filter ? filter.value : null}
                        onChange={date => onChange(date)}
                        placeholder=""
                    />
                )
            },
            {
                Header: "Prev. IW",
                accessor: "oldEmployee"
            },
            {
                Header: "New IW",
                accessor: "newEmployee"
            },
            {
                id: "isTemporary",
                Header: "Temp?",
                accessor: original => (original.isTemporary ? "Yes" : "No"),
                Cell: ({ original }) => (original.isTemporary ? "Yes" : "No"),
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Yes",
                            NO: "No"
                        }}
                    />
                )
            },
            {
                id: "sendBackup",
                Header: "Send Backup",
                accessor: original => (original.sendBackup ? "Yes" : "No"),
                Cell: ({ original }) => (original.sendBackup ? "Yes" : "No"),
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Yes",
                            NO: "No"
                        }}
                    />
                )
            },
            {
                id: "sendSupply",
                Header: "Send Supply",
                accessor: original => (original.sendSupply ? "Yes" : "No"),
                Cell: ({ original }) => (original.sendSupply ? "Yes" : "No"),
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Yes",
                            NO: "No"
                        }}
                    />
                )
            },
            {
                Header: "Modified By",
                accessor: "modifiedBy"
            },
            /*
            {
              Header: "Modified",
              id: "dateModified",
              accessor: "dateModified",
              Cell: ({ original }) => moment(original.dateModified).fromNow()
            },
            */
            {
                Header: "Acted",
                id: "isActed",
                // accessor: "isActed",
                accessor: original => (original.isActed ? "Yes" : "No"),
                // eslint-disable-next-line no-nested-ternary
                Cell: ({ original }) => (original.isActed
                        ? (
                            <FontAwesomeIcon
                                icon="check-circle"
                                className="text-success"
                            />
                        )
                        : (showActButton
                            ?
                            <button
                                className="btn btn-primary btn-block btn-sm"
                                onClick={() => this.handleAct(original.id)}
                            >
                                Act
                            </button>
                            : null
                        )
                ),
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Yes",
                            NO: "No"
                        }}
                    />
                ),
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }
            }
        ];
    };

    makeRequest = () => {
        this.props.fetchServiceReassignment(
            this.state.startDate,
            this.state.endDate
        );
    };

    handleAct = (id) => {
        this.props.actServiceReassignment(id, () => {
            this.makeRequest();
            toast("Acted successfully", {
                type: toast.TYPE.SUCCESS,
            });
        });
    };

    handleFilter = (startDate, endDate) => {
        this.setState({
            startDate,
            endDate
        }, this.makeRequest);
    };

    render() {
        const {
            serviceReassignment
        } = this.props;

        return (
            <div className="card">
                <div className="card-header p-1 pl-2 pr-2">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>Service Reassignment</div>
                        <ServiceReassignmentWidgetFilter
                            onSubmit={this.handleFilter}
                        />
                    </div>
                </div>
                <div className="card-body p-0">
                    <ReactTable
                        data={serviceReassignment}
                        headerClassName="table-header"
                        columns={this.getColumns()}
                        defaultPageSize={20}
                        pageSizeOptions={[10, 20, 50, 100]}
                        resizable
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        className="-striped -highlight schedules-table"
                        style={{
                            height: "calc(100vh - 220px)",
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userRole: state.auth.user.role,
    serviceReassignment: state.dashboard.serviceReassignment
});

const mapStateToDispatch = dispatch => ({
    fetchServiceReassignment: bindActionCreators(
        fetchServiceReassignment,
        dispatch
    ),
    actServiceReassignment: bindActionCreators(actServiceReassignment, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ServiceReassignmentWidget);
